import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/1_card_back_blue/1_card_back_blue"
 * Contains 1 texture(s)
 */
export class CardsBacks1CardBackBlueAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/1_card_back_blue/1_card_back_blue';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '1_blue.png'
    ] as const;
}
